import API from "../services/api";
import EventOption from "../models/event/EventOption";

export default class EventOptionRepository {
    static all = (event, group, language = null) => API.get('/event/option/all?event=' + event + '&group=' + group).then(response => response.data.options.map(option => EventOption.fromJson(option, language)));
    static get = (id, event, language = null) => API.get('/event/option/details/' + id + '?event=' + event).then(response => EventOption.fromJson(response.data.option, language));

    static create = (data) => API.post('/event/option/create', data);
    static update = (data) => API.post('/event/option/update', data);
    static toggle = (data) => API.post('/event/option/toggle', data).then(response => response.data.active);
    static updateOrder = (event, group, tree) => API.post('/event/option/update/order', { event: event, group: group, tree: tree });
    static delete = (data) => API.delete('/event/option/delete?id=' + data.id + '&event=' + data.event);
}
